import React from 'react';
// $FlowIgnore
import Button from 'components/UIKit/Button/Button';
import Column from 'components/UIKit/Flex/Column';

// modalWidth: width is for an IE11 fix

let InitialDisclaimer = ({ handleClick, modalWidth: width }) => {
  return (
    <Column style={{padding: '10px', alignItems: 'center'}}>
      <p style={{ width }}>
        Data Sharing Requirement: By submitting data to the GDC, a submitter
        indicates understanding and agreement that data will be made available to
        the scientific community at large, according to the data submitter's Genomic
        Data Sharing Plan as required. Controlled access data will be made available
        to members of the community having the appropriate dbGaP Data Use Certification.
        The GDC will also produce harmonized data (raw and derived) based on the originally submitted data.
      </p>
      <p style={{ width }}>
        NOTE: The GDC will not preserve an exact copy of the originally submitted
        data; however, the GDC will preserve the original reads and quality scores.
      </p>
      <p style={{ width }}>
        After data is released, either by submitter request to the GDC, or by approval
        of the Center for Cancer Genomics, harmonized raw and GDC-generated derived
        data will be made available to the public via the GDC Data Portal and GDC data access tools.
      </p>
      <Button
        customDataTestID="button-ok-disclaimer"
        style={{width: '30px', height: '30px'}}
        onClick={handleClick}
      >
        OK
      </Button>
    </Column>
  );
};

export default InitialDisclaimer;
